import * as Common from '@/tenant/common';

export class Project extends Common.ObjectBase{
  constructor(){
    super('Project')
  }
  public key: string = '';
  public name: string="";
  public pid: string ="";
  public members: string[] =new Array();
}

export class ProjectQuery extends Common.LoadQuery {
  constructor(){
    super('ProjectQuery',Project);
    this.sort = 'Key';    
  }

  public key: string = '';
}

export class ProjectMasterQuery extends Common.LoadQuery {
  constructor(){
    super('ProjectMasterQuery',Project);
  }
}